import React from 'react';
import { ConnectedProps, connect } from 'react-redux';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Co... Remove this comment to see the full error message
import { ContextRouter, withRouter } from 'react-router';

import {
  clearFlashMessages,
  pushFlashMessage,
} from 'store/main/ducks/flashMessages';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/ban-types
type InitialProps = {};
type OwnProps = InitialProps & ContextRouter;
type Props = OwnProps & PropsFromRedux;

class SetFlashMessages extends React.PureComponent<Props> {
  componentDidUpdate(prevProps: Props) {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // clear flash messages on page navigation
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      this.props.clearFlashMessages();
    }

    if (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      prevProps.location.pathname !== this.props.location.pathname || // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      prevProps.location.state !== this.props.location.state
    ) {
      // load new flash message from router state
      const flashMessage =
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.location.state && this.props.location.state.flashMessage;

      if (flashMessage) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.pushFlashMessage(flashMessage, true);
      }
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = ({ flashMessages }) => ({
  flashMessages,
});

const connector = connect(mapStateToProps, {
  pushFlashMessage,
  clearFlashMessages,
});

type PropsFromRedux = ConnectedProps<typeof connector>;

// @ts-expect-error ts-migrate(2558) FIXME: Expected 2 type arguments, but got 1.
// eslint-disable-next-line import/no-default-export
export default withRouter<InitialProps>(connector(SetFlashMessages));
